// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  height: 100dvh;
  width: 100dvw;
}
:host.menubar-top {
  flex-direction: column;
}
:host.menubar-top gridster-item.is-docked {
  --menubar-offset: 40px;
  height: calc(100vh - var(--menubar-offset)) !important;
  top: var(--menubar-offset) !important;
}
:host.menubar-left {
  flex-direction: row;
}
:host.menubar-right {
  flex-direction: row-reverse;
}
:host.menubar-bottom {
  flex-direction: column-reverse;
}
:host.menubar-bottom gridster-item.is-docked {
  --menubar-offset: 40px;
  height: calc(100vh - var(--menubar-offset)) !important;
  bottom: var(--menubar-offset) !important;
  top: auto !important;
}

.main-content {
  display: flex;
  flex: 1;
  overflow: hidden;
  position: relative;
}

gridster, .gridster-main {
  background: transparent;
  overflow: hidden !important;
  flex-grow: 1;
}

gridster-item {
  border: 1px solid silver;
}
gridster-item .close-button {
  display: none;
}
gridster-item:hover .close-button {
  display: block;
}
gridster-item .titlebar {
  display: none;
}
gridster-item:hover .titlebar {
  display: block;
}
gridster-item.is-docked {
  position: fixed !important;
  z-index: 1000;
  border: 1px solid rgba(128, 128, 128, 0.5);
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.3);
  transform: none !important;
  width: var(--dock-width) !important;
  height: 100vh !important;
  top: 0 !important;
}
gridster-item.is-docked ::ng-deep .gridster-item-resizable-handler {
  display: none !important;
}
gridster-item.docked-left {
  left: 0 !important;
  right: auto !important;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.3);
}
gridster-item.docked-right {
  right: 0 !important;
  left: auto !important;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.3);
}

gridster-item-content {
  overflow: auto;
  overflow-x: hidden;
}

app-chat-widget {
  display: block;
  height: 100%;
}

.dockview-container {
  flex: 1;
  height: 100%;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/pages/grid-page/grid-page.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,cAAA;EACA,aAAA;AACF;AACE;EACE,sBAAA;AACJ;AAEI;EACE,sBAAA;EACA,sDAAA;EACA,qCAAA;AAAN;AAIE;EACE,mBAAA;AAFJ;AAKE;EACE,2BAAA;AAHJ;AAME;EACE,8BAAA;AAJJ;AAMI;EACE,sBAAA;EACA,sDAAA;EACA,wCAAA;EACA,oBAAA;AAJN;;AASA;EACE,aAAA;EACA,OAAA;EACA,gBAAA;EACA,kBAAA;AANF;;AASA;EACE,uBAAA;EACA,2BAAA;EACA,YAAA;AANF;;AASA;EACE,wBAAA;AANF;AAQE;EACE,aAAA;AANJ;AASE;EACE,cAAA;AAPJ;AAUE;EACE,aAAA;AARJ;AAWE;EACE,cAAA;AATJ;AAaE;EACE,0BAAA;EACA,aAAA;EACA,0CAAA;EACA,yCAAA;EAGA,0BAAA;EAGA,mCAAA;EAGA,wBAAA;EACA,iBAAA;AAjBJ;AAoBI;EACE,wBAAA;AAlBN;AAsBE;EACE,kBAAA;EACA,sBAAA;EACA,wCAAA;AApBJ;AAuBE;EACE,mBAAA;EACA,qBAAA;EACA,yCAAA;AArBJ;;AAyBA;EACE,cAAA;EACA,kBAAA;AAtBF;;AAyBA;EACE,cAAA;EACA,YAAA;AAtBF;;AA0BA;EACE,OAAA;EACA,YAAA;EACA,WAAA;AAvBF","sourcesContent":[":host {\n  display: flex;\n  height: 100dvh;\n  width: 100dvw;\n\n  &.menubar-top {\n    flex-direction: column;\n\n    // When menubar is on top, docked widgets need to account for menubar height\n    gridster-item.is-docked {\n      --menubar-offset: 40px;\n      height: calc(100vh - var(--menubar-offset)) !important;\n      top: var(--menubar-offset) !important;\n    }\n  }\n\n  &.menubar-left {\n    flex-direction: row;\n  }\n\n  &.menubar-right {\n    flex-direction: row-reverse;\n  }\n\n  &.menubar-bottom {\n    flex-direction: column-reverse;\n\n    gridster-item.is-docked {\n      --menubar-offset: 40px;\n      height: calc(100vh - var(--menubar-offset)) !important;\n      bottom: var(--menubar-offset) !important;\n      top: auto !important;\n    }\n  }\n}\n\n.main-content {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n  position: relative;\n}\n\ngridster, .gridster-main {\n  background: transparent;\n  overflow: hidden !important;\n  flex-grow: 1;\n}\n\ngridster-item {\n  border: 1px solid silver;\n\n  & .close-button {\n    display: none;\n  }\n\n  &:hover .close-button {\n    display: block;\n  }\n\n  & .titlebar {\n    display: none;\n  }\n\n  &:hover .titlebar {\n    display: block;\n  }\n\n  // Docked widget styling - overlay on top of gridster\n  &.is-docked {\n    position: fixed !important;\n    z-index: 1000;\n    border: 1px solid rgba(128, 128, 128, 0.5);\n    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.3);\n\n    // Reset any gridster transforms\n    transform: none !important;\n\n    // Width comes from the dock zone size (50% of viewport)\n    width: var(--dock-width) !important;\n\n    // Default: full height, pinned to top (for left menubar)\n    height: 100vh !important;\n    top: 0 !important;\n\n    // Hide gridster resize handles when docked\n    ::ng-deep .gridster-item-resizable-handler {\n      display: none !important;\n    }\n  }\n\n  &.docked-left {\n    left: 0 !important;\n    right: auto !important;\n    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.3);\n  }\n\n  &.docked-right {\n    right: 0 !important;\n    left: auto !important;\n    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.3);\n  }\n}\n\ngridster-item-content {\n  overflow: auto;\n  overflow-x: hidden;\n}\n\napp-chat-widget {\n  display: block;\n  height: 100%;\n}\n\n// Dockview container fills the main content area\n.dockview-container {\n  flex: 1;\n  height: 100%;\n  width: 100%;\n\n  // Background and opacity for dockview panels are set in _base-widget-theme.scss\n  // (mirrors gridster-item rules)\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
